/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import DrawDaysPopup from 'components/enter/DrawDaysPopup';
import MenuSection from 'components/layout/header/MenuSection';
import { extendClassName } from 'utils/common';
import BoxWithWhiteFill from 'components/common/Box/BoxWithWhiteFill';
import { Switches } from './Switches';
import { Heading } from './Heading';

const DrawDaysSelector = ({
  tuesdayDrawEnabled,
  setTuesdayDrawEnabled,
  fridayDrawEnabled,
  setFridayDrawEnabled,
  onAnyUserAction = () => {},
  collapsible,
  glowColor = undefined,
  outline = false,
  useDefaultHeading = false,
  useDefaultPadding = false,
  additionalClassName = undefined,
}) => {
  const [showDrawDaysPopup, setShowDrawDaysPopup] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={extendClassName('drawDaysSelector flexCentered', [
        collapsible && 'collapsible',
        additionalClassName,
      ])}
    >
      {showDrawDaysPopup && (
        <DrawDaysPopup onClose={() => setShowDrawDaysPopup(false)} />
      )}

      {collapsible ? (
        <MenuSection
          expanded={expanded}
          setExpanded={setExpanded}
          titleComponent={
            <>
              <img
                src={`${ASSET_PREFIX}/images/enter/calendar-icon.svg`}
                style={{
                  display: 'inline',
                  verticalAlign: 'middle',
                  marginRight: '0.9em',
                  width: '20px',
                }}
                alt=""
              />
              {useDefaultHeading && (
                <Heading setShowDrawDaysPopup={setShowDrawDaysPopup} />
              )}
            </>
          }
          id={undefined}
          preExpanded={undefined}
          style={undefined}
        >
          <BoxWithWhiteFill
            centerVertical
            centerHorizontal
            additionalClassName="fullWidth"
          >
            <Switches
              tuesdayDrawEnabled={tuesdayDrawEnabled}
              setTuesdayDrawEnabled={setTuesdayDrawEnabled}
              fridayDrawEnabled={fridayDrawEnabled}
              setFridayDrawEnabled={setFridayDrawEnabled}
              onAnyUserAction={onAnyUserAction}
              glowColor={glowColor}
            />
          </BoxWithWhiteFill>
        </MenuSection>
      ) : (
        <>
          {useDefaultHeading && (
            <Heading setShowDrawDaysPopup={setShowDrawDaysPopup} />
          )}
          <Switches
            tuesdayDrawEnabled={tuesdayDrawEnabled}
            setTuesdayDrawEnabled={setTuesdayDrawEnabled}
            fridayDrawEnabled={fridayDrawEnabled}
            setFridayDrawEnabled={setFridayDrawEnabled}
            onAnyUserAction={onAnyUserAction}
            glowColor={glowColor}
          />
        </>
      )}

      <style jsx>
        {`
          .drawDaysSelector {
            ${outline ? 'border: 3px solid ${colors.primaryBrandGray}25;' : ''}
            border-radius: 10px;
            ${useDefaultPadding ? 'padding: 3em 2em;' : ''}
            width: 100%;
          }

          .drawDaysSelector.collapsible {
            border: none;
            padding: 0;
          }

          :global(.drawDaysSelector.collapsible .menuSection .childrenSection) {
            align-items: center;
          }

          :global(.drawDaysSelector.collapsible .menuSection .sectionTitle),
          :global(
              .drawDaysSelector.collapsible .menuSection .sectionTitle.noSelect
            ) {
            padding: 0;
          }

          :global(.drawDaysSelector.collapsible .menuSection .titleContainer) {
            display: flex;
            text-transform: none;
          }

          :global(.drawDaysSelector.collapsible .menuSection p.heading) {
            margin: 0;
            font-size: 1em;
          }
        `}
      </style>
    </div>
  );
};

export default DrawDaysSelector;
